/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, February 21st 2022, 12:39:12 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { NODE_TYPES } from "lib/schemas";
import { BPMNDraggableNodeTypeButton } from "./BPMNDraggableNodeTypeButton";

export const AddNewBPMNNodeToolSet = () => {
  return (
    <>
      {/* Disabled because the backend automatically adds a start event when a process definition is created. For now, a workflow in OneStop can only  have one start event. */}
      {/* <BPMNDraggableNodeTypeButton
        typeTitle={NODE_TYPES.StartFunction}
        tooltipText="This is an automated action designating the beginning of the workflow. If you do not add this to your workflow, it will be automatically added."
        newNodeType="StartFunction"
        newNodeTitle="Beginning"
      /> */}

      <BPMNDraggableNodeTypeButton
        typeTitle={NODE_TYPES.View}
        tooltipText="This is a task that requires human interaction."
        newNodeType="View"
        newNodeTitle="Perform Action"
      />

      <BPMNDraggableNodeTypeButton
        typeTitle={NODE_TYPES.Handler}
        tooltipText="This type of task is an automated action such as the generation of a document, sending of an email/sms notification, automated billing etc."
        newNodeType="Handler"
        newNodeTitle="Automated Service"
      />

      <BPMNDraggableNodeTypeButton
        typeTitle={NODE_TYPES.Split}
        tooltipText="This is an automated point in the workflow that branches the workflow to one or more next step(s). It can be used to set concurrent tasks or even determine one among many outgoing branches based on input from the submission form or assessment task forms."
        newNodeType="Split"
        newNodeTitle="Auto-Split"
      />

      <BPMNDraggableNodeTypeButton
        typeTitle={NODE_TYPES.Join}
        tooltipText="This is an automated action that converges multiple steps to a single path in the workflow. An example use case is when multiple users carry out tasks in a workflow (created by a split) and all their tasks must be completed before the workflow process continues."
        newNodeType="Join"
        newNodeTitle="Auto-Merge"
      />

      {/* Job nodes not yet implemented */}
      {/* <BPMNDraggableNodeTypeButton
        typeTitle={NODE_TYPES.Job}
        tooltipText="This is an automated action that you schedule to occur at a certain period(s)"
        newNodeType="Job"
        newNodeTitle="Scheduled Job"
      /> */}

      <BPMNDraggableNodeTypeButton
        typeTitle={NODE_TYPES.Event}
        tooltipText="Events that occur between the start and end of a process. This workflow step can either throw an event (to be caught by other activities or subprocesses) or catch an event (that is thrown by other activities or subprocesses)."
        newNodeType="Event"
        newNodeTitle="Intermediate Event"
      />

      <BPMNDraggableNodeTypeButton
        typeTitle={NODE_TYPES.Call}
        tooltipText="This is a task that calls another process (Subprocess). Thus your current process (Upstream process) will pause at this task until the subprocess / downstream process is completed. This is useful for breaking down complex processes into simpler sub-processes or when you have a common set of tasks that are shared across multiple processes."
        newNodeType="Call"
        newNodeTitle="Call Activity"
      />

      <BPMNDraggableNodeTypeButton
        typeTitle={NODE_TYPES.End}
        tooltipText="This is an automated step designating the termination of the workflow process. You can have an unlimited number of end events."
        newNodeType="End"
        newNodeTitle="End"
      />
    </>
  );
};
